import CardButton from '@/common/components/cardButton/CardButton';
import { Box } from 'styled-system/jsx';
import FileInfoEntryTabIcon from '@/common/assets/icons/fileInfoEntryTab.svg?react';
import useModal from '@/common/hooks/useModal';
import FileInformationModal from '@/modules/FileDetail/components/fileInformation/modals/FileInformationModal/FileInformationModal.tsx';
import { FileInformationCardProps } from '@/modules/FileDetail/components/fileInformation/entryTabs/FileInformationCard/FileInformationCard.types.ts';

const FileInformationCard = ({ title }: FileInformationCardProps) => {
  const { open, openModal, closeModal } = useModal();
  const renderIcon = () => {
    return <FileInfoEntryTabIcon />;
  };

  return (
    <>
      <Box onClick={openModal} mb="16px">
        <CardButton hasArrow renderIcon={renderIcon} title={title} />
      </Box>
      <FileInformationModal closeModal={closeModal} open={open} />
    </>
  );
};
export default FileInformationCard;
